import { authApi } from '../../apiInstances'
import { ILoginResponse } from '../../../types/auth'

export default {
  login(username: string, password: string): Promise<ILoginResponse> {
    return authApi.post('/login', new URLSearchParams({ username, password }), {
      convertRequestBodyToSnakeCase: false,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })
  },
}
